import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import * as constants from '../../config/constants/AppConstants';
import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

const UI_SIZE = constants.AppSettings.UI_SIZE;
class CommonDropdown extends Component {

    constructor(props) {
        super(props);     
    }
    
    render = () => {
        
        let props = this.props;

        let { id, value } = props?.input;

        let { element, option, callback, width="100%", size='', disabled = false } = props;

        let { source, section, item, data } = option

        let lists = (options?.[section]?.[item]) ? options[section][item] : {};

        const selected = lists?.options?.find(option => option.id === value) || lists?.options?.[0] || null;

        const variant = selected?.variant || "primary";

        const fontSizeClass = size === 'sm' ? 'dropdown-font-sm' : '';

        const title = (
            <>
                {selected?.icon && (
                    <i 
                        className={selected?.icon} 
                        style={{ marginRight: selected?.label === '' ? "0px" : "4px" }} 
                    />
                )} 
                {selected?.label}
            </>
        );

            return (
                <Dropdown
                    show={!disabled ? undefined : false} 
                    onSelect={(eventKey) => { 
                        if (disabled) return; 
                        const customEvent = {
                            target: {
                                name: id,
                                type: "dropdown",
                                value: eventKey,
                            }
                        };
                        callback(customEvent, element);
                    }}
                    style={{width: width}}
                >
                    <Dropdown.Toggle as={Button} id={id} variant={variant} size={UI_SIZE} disabled={disabled} className={`custom-dropdown ${fontSizeClass}`} style={{width: width}}>
                        {title}
                    </Dropdown.Toggle>

                    {! disabled  && (
                        <Dropdown.Menu>
                            {lists?.options
                                ?.filter(option => option.value !== selected?.value) 
                                .map(option => (
                                    <Dropdown.Item key={option.id} eventKey={option.value} className={`dropdown-item-sm ${fontSizeClass}`} style={{width: width}}>
                                        {option.icon && <i className={`${option.icon} me-2`} style={{ marginRight: "6px" }} />} 
                                        {option.label}
                                    </Dropdown.Item>
                                ))}
                        </Dropdown.Menu>
                    )}
                </Dropdown>
            )
    }
}

export default CommonDropdown;